<ng-container>
	<div fxLayout="column" fxLayout.lt-sm="column" style="height: auto;">
		<div *ngIf="!login">
			<div fxLayout="row" fxLayoutAlign="space-around" style="height: 100vh;background-image: url('/images/hero.png');background-size: cover;">
				<div fxLayout="column" fxLayoutAlign="space-around">
					<mat-card style="border-width: 12px;border-color: #707070;">
						<mat-card-header>
							<mat-card-title><span data-idtest="top-t-1Gi" style="color: rgb(191 143 79);font-weight: 600;" translate>AIGIAマイページログイン</span></mat-card-title>
						</mat-card-header>
						<mat-card-content fxLayout="column">
							<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
								<mat-form-field appearance="outline" fxFlex="90">
									<mat-label><span data-idtest="top-t-6Zv" translate>メールアドレス</span></mat-label>
									<input data-idtest="top-i-0Dq" #username_field="ngModel" [(ngModel)]="username" autocomplete="off" email matInput maxlength="255" minlength="3" name="username_field" placeholder="{{'メールアドレス' | translate }}" required type="email" data-test="username">
									<mat-error *ngIf="username_field.errors?.['email'];"><span data-idtest="top-t-1Jd" translate>有効なメールアドレスで</span></mat-error>
									<mat-error *ngIf="username_field.errors?.['required'];"><span data-idtest="top-t-1Mo" translate>入力してください</span></mat-error>
									<mat-error *ngIf="username_field.errors?.['maxlength']"><span data-idtest="top-t-3Qd" translate>長すぎます</span></mat-error>
									<mat-error *ngIf="username_field.errors?.['minlength']"><span data-idtest="top-t-8Zz" translate>短すぎます</span></mat-error>
								</mat-form-field>

								<mat-form-field appearance="outline" fxFlex="90">
									<mat-label><span data-idtest="top-t-9Io" translate>パスワード</span></mat-label>
									<input data-idtest="top-i-0Dw" #password_field="ngModel" [(ngModel)]="password" matInput maxlength="100" name="password_field" placeholder="{{'パスワード' | translate }}" required type="password" data-test="password-h">
								</mat-form-field>

							</form>
							<div fxFlex="100" fxLayout="column" fxLayoutAlign="center" fxLayoutAlign.lt-sm="center">
								<div fxFlex="60" fxLayoutAlign="center" style="margin:24px 0;">
									<button data-idtest="top-b-4Nw" (click)="onAccept()" [disabled]="form.invalid" color="primary" fxFlex="60" mat-raised-button data-test="login"><span data-idtest="top-t-7Uh" translate>ログイン</span></button>
								</div>
								<!-- <div fxFlex="100" fxLayoutAlign="center center" style="margin:12px;">
									<a aigia-password-button class="link-color" style="font-size:10px;"><span data-idtest="top-t-4El" translate>パスワードをお忘れの方はこちら></span></a>
								</div> -->
							</div>
						</mat-card-content>
					</mat-card>
				</div>
			</div>
		</div>
	</div>
</ng-container>
